<template>
  <div class="d-a-c lh30 ww100 pt22">

    <div class="pt30 tc" style="width: 80px;">
      <p class="gray9 ">今日</p>
      <p class="gray9">昨日</p>
    </div>
    <div class="flex-1 tc">
      <p class="word" style="color:#37a5f3">累积商户数
        <el-tooltip class="item" effect="dark" content="所有的商户数之和" placement="top-start">
          <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
        </el-tooltip>
      </p>
      <p class="f20 fb gray3 today_num" style="color:#37a5f3">{{dataModel.supplier.supplier_total.today}}</p>
      <p class="gray yes_num">{{dataModel.supplier.supplier_total.yesterday}}</p>
    </div>
    <div class="flex-1 tc">
      <p class="word" style="color:#008000">新增商户数
        <el-tooltip class="item" effect="dark" content="这是今日新增的商户数哦" placement="top-start">
          <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
        </el-tooltip>
      </p>
      <p class="f20 fb gray3 today_num" style="color:#008000">{{dataModel.supplier.supplier_add.today}}</p>
      <p class="gray yes_num">{{dataModel.supplier.supplier_add.yesterday}}</p>
    </div>
    <div class="flex-1 tc">
      <p class="word" style="color:#dc362e">新申请商户数
        <el-tooltip class="item" effect="dark" content="今日有新增的商户提交申请了呢" placement="top-start">
          <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
        </el-tooltip>
      </p>
      <p class="f20 fb gray3 today_num" style="color:#dc362e">{{dataModel.supplier.supplier_apply.today}}</p>
      <p class="gray yes_num">{{dataModel.supplier.supplier_apply.yesterday}}</p>
    </div>
    <div class="flex-1 tc">
      <p class="word" style="color:#ffa500">商户退出数
        <el-tooltip class="item" effect="dark" content="今日有商户退出" placement="top-start">
          <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
        </el-tooltip>
      </p>
      <p class="f20 fb gray3 today_num" style="color:#ffa500">{{dataModel.supplier.supplier_refund.today}}</p>
      <p class="gray yes_num">{{dataModel.supplier.supplier_refund.yesterday}}</p>
    </div>
    <div class="flex-1 tc">
      <p class="word" style="color:#c424ff">商户退出申请数
        <el-tooltip class="item" effect="dark" content="商户退出总统计" placement="top-start">
          <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
        </el-tooltip>
      </p>
      <p class="f20 fb gray3 today_num" style="color:#c424ff">{{dataModel.supplier.supplier_refund_apply.today}}</p>
      <p class="gray yes_num">{{dataModel.supplier.supplier_refund_apply.yesterday}}</p>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true
    };
  },
  inject: ["dataModel"],
  created() {},
  methods: {}
};
</script>

<style scoped>
.word {
  font-size: 20px;
  font-weight: 600;
}
.today_num {
  margin-top: 10px;
  font-size: 24px;
}
.yes_num {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/supplier/part/Total.vue